// false positive on eslint rule below
// eslint-disable-next-line no-shadow
export enum RecoilKeys {
  Countries = "4b3e5744a9ce458cb5c9f95759884ed4",
  CountryAdministrativeAreas = "1bd1f17c8f9a4195a849710c8cc878d7",
  CourierValue = "fcb0a618ebb643898f9a697be85a4f29",
  PaidCourierToggleState = "dc6a8ee3c6a34c5fa87559307b924bcd",
  SampleCourierValue = "a9eed5bbf5a949459b8ada1f7135b12f",
  HasAcceptedTOS = "6c4428c8d6c4479eb217605c380479c3",
  IsShowBillingForm = "789961b413dd40ce998ea207fe24bff8",
  IsThirdParty = "e759961444f143e58fed5f944697eea3",
  LastAddedOrderLine = "cbce565c01e54a32a1c97cec0e40c189",
  Order = "96225db1a225464da493d26014c1ce1b",
  OrderErrorEvent = "455eb6bc0792458d8988b3e9127f44e4",
  OrderMutationPending = "6cadf29851b248e39c8293ea939ccb9f",
  SavedShippingAddresses = "3e89992f6d3e445eadd3a2b0748d2b7e",
  SelectedShippingAddressId = "147812850f3049c0b9f76c640091dfaf",
  SelectedPurchaseShipMethod = "03b7e8fefc5f442082ac66634ce5b707",
  SelectedPurchaseInstockShipMethod = "57be32e33ba0490c830a35c49ca45df0",
  SelectedMarketPlaceShipMethod = "d4e5f6g7h8i9j0k1l2m3n4o5p6q7r8s9",
  SelectedPurchaseBackOrderShipMethod = "5ae10725e8ce4e438db455fbed2e8239",
  SelectedSampleShipMethod = "a062132ff11d4480813399d1fd55a88c",
  Settings = "08d781c57fa24979ba17c03964f3fc9d",
  ShippingOptionChange = "6d183450be57484fa9d2d363481d1884",
  SplitPackageCartLines = "215646e7b4aa48d79bf41555e4836dcf",
  SplitSampleCartLines = "6d42f602289849408bcc2e8d51dd6b13",
  LookupProductSample = "312a5ae9656a496f92c1dc136643115f",
  Toasts = "33c36297da9c45bc9a73b760edccd254",
  ShippingOptions = "88631da08f47457dbe381390ca46df1c",
  ShipmentTypeValue = "a6f247fe671c4e37bdf41bab4ac130fa",
  ErrorQuantityInput = "ce0ed78eeb8b46629b92b2fc22b50644",
  LookupPricing = "0bfcfc37315746f5804b3c89b1bc442a",
  PhrasesAPIError = "5c501cc384f440619b56e78462640e6d",
  SampleQuestions = "5a3478f17d514341b8b5672e887441ad",
  LinePartAdjusted = "8fb56f20ad884c84988efb1503be64a5",
}
